
import { mapState } from 'vuex'
import dealerTisk from '@/components/textTrader/_openWebsiteTip.vue'
import dealerModule from '@/components/dealer/head/dealerModule.vue'

export default {
  components: {
    'dealer-tisk': dealerTisk,
    'dealer-module': dealerModule
  },
  inject: ['info'],
  props: {
    tips: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    const weburl = []
    this.info &&
      this.info.webSite &&
      this.info.webSite.forEach((item) => {
        if (item.type == 1) {
          weburl.push(item)
        }
      })

    return {
      websites: weburl,
      moduleShow: false,
      urltype: 'webUrl', // 网址跳转类型
      iframeshow: false,
      iframeurl: '',
      tipstype: '',
      ourl: ''
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile'
    }),
    isShort() {
      return 'zh-cn,zh'.includes(this.$store.state.LanguageCode)
    },
    isLong() {
      return 'fr,ru,es,pt'.includes(this.$store.state.LanguageCode)
    },
    getHeightForLan() {
      if (this.isShort) {
        return '60px'
      } else if (this.isLong) {
        return '88px'
      } else {
        return '72px'
      }
    },
    getWidthForLan() {
      if (this.isShort) {
        return '205px'
      } else if (this.isLong) {
        return '255px'
      } else {
        return '229px'
      }
    }
  },
  methods: {
    async statistics(type, url, code = '') {
      // 统计type为1--浏览模式默认；type为2---广告点击；3---点击模式官方网址；4---开户网址；5---品专官方网址；6---品专开户地址;7---品专默认
      let spots = 5
      if (type == '1' && !this.$store.state.allHost.includes('brand=1')) spots = 5
      else if (type == '2')
        spots = 3 // 广告
      else if (type == '3' && !this.$store.state.allHost.includes('brand=1')) spots = 1
      else if (type == '4' && !this.$store.state.allHost.includes('brand=1')) spots = 4
      else if (type == '5' && this.$store.state.allHost.includes('brand=1')) spots = 11
      else if (type == '6' && this.$store.state.allHost.includes('brand=1')) spots = 12
      else if (type == '7' && this.$store.state.allHost.includes('brand=1')) spots = 10
      else if (type == '21') spots = 21
      else if (type == '20') spots = 20
      const param = {
        userid: this.$store.state.user.userId ? this.$store.state.user.userId : '', // 用户标识
        equipId: this.$Cookie.get('wiki-bfp'),
        platform: 3, // 平台类型
        apptype: 0, // 客户端类型
        ip: this.$store.state.userIp, // 用户ip
        ver: '0', // 版本
        equipinfo: 0, // 客户端类型
        country: this.$store.state.CountryCode, // 当前国家
        lang: this.$store.state.LanguageCode, // 当前语言
        type: 1, // 浏览类型
        code: code || this.info.traderCode, // 交易商code
        spots, // 点位类型 1网址 3广告 4开户网址 11品专网址 12品专开户网址
        url, // 对应网址
        jumpStatisticsUrl: this.$store.state.allHost
      }
      await this.$api.dealer.statistics(param).then((ret) => {
        console.log('网址弹窗iframe', ret)
        if (ret && ret.url) {
          if (type == '6' || type == '4' || type == '5' || type == '3') {
            const u = ret.url.includes('http') ? ret.url : `https://${ret.url}`
            this.iframeurl = u
            this.tipstype = String(ret.type)
          } else if (type == '20' || type == '21') {
            this.tipstype = String(ret.type)
          }
        }
      })
    },
    async openUlr(item) {
      // 官方网址
      if (this.$store.state.riskcontrol['91017'] == '2') return
      const tt = !item.url ? (this.websites ? this.websites[0].url : '') : item.url
      if (!item.isLegal) return
      try {
        window.gtag('event', 'click', {
          event_category: 'click',
          event_label: 'click website'
        })
      } catch (err) {}
      this.ourl = tt
      await this.statistics('3', tt)
      if (this.tips && this.tips.title) {
        setTimeout(() => {
          this.urltype = 'sites'
          this.moduleShow = true
          this.$nextTick(() => {
            this.$refs.tisk.open()
          })
        }, 1000)
      } else {
        this.$nextTick(() => {
          if (this.tipstype == '0') {
            this.iframeshow = true
          } else {
            const a = document.createElement('a')
            a.setAttribute('href', tt)
            a.setAttribute('target', '_blank')
            a.setAttribute('id', 'startTelMedicine')
            // 防止反复添加
            if (document.getElementById('startTelMedicine')) {
              document.body.removeChild(document.getElementById('startTelMedicine'))
            }
            document.body.appendChild(a)
            a.click()
          }
        })
      }
    },
    iframeif(bool) {
      // iframe显示状态
      this.iframeshow = bool
    },
    close() {
      // 关闭弹框
      this.moduleShow = false
      document.body.style.overflow = 'auto'
      this.$nextTick(() => {
        this.$refs.tisk && this.$refs.tisk.close()
      })
    },
    gotopinlun() {
      const code = this.info.traderCode
      window.open(`/${this.$store.state.LanguageCode}/comments/add/${code}.html?from=texttrader`)
    },
    ALB() {
      return this.$store.state.LanguageCode == 'ar' ? 'ALB' : ''
    }
  }
}
